import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M207 381.5L12.7 187.1C3.3 177.8 3.3 162.6 12.7 153.2L35.4 130.5C44.7 121.2 59.9 121.1 69.3 130.5L224 284.5 378.7 130.5C388.1 121.1 403.3 121.2 412.6 130.5L435.3 153.2C444.7 162.6 444.7 177.8 435.3 187.1L241 381.5C231.6 390.8 216.4 390.8 207 381.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-down.js
// module id = e0Rn
// module chunks = 144